import { useTranslation } from 'react-i18next';
import { FormAdditionalEvidence } from '../../../../components/form/FormAdditionalEvidence';
import { FormEvidence } from '../../../../components/form/FormEvidence';
import MultipleFileUploader from '../../../../components/form/MultipleFileUploader';
export const OtherEvidence = (props) => {
  const { register, errors, watch, setValue, control, evidenceList, updatedEvidence } = props;
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';

  console.log('evidenceList', evidenceList);
  console.log('evidenceList watch', watch('evidence'));

  return (
    <article className='flex flex-col gap-4 w-[945px] mb-4 py-8'>
      <article className='flex flex-col gap-4 w-[945px] mb-4 pb-8'>
        <header>
          <h2 className='font-semibold mb-4 pb-2'>{t('BEFORE_AFTER_IMAGE')}</h2>
        </header>
        <div className='flex flex-col gap-4'>
          <MultipleFileUploader
            control={control}
            name='beforeImages'
            label={t('BEFORE_BIZ_IMAGE')}
            path='project/editor'
            fileType='image'
            max={10}
            error={errors.beforeImages}
            rules={{
              required: isEn ? 'Please upload the before images.' : '이전 이미지를 업로드해주세요.',
            }}
            required
          />
          <MultipleFileUploader
            control={control}
            name='afterImages'
            label={t('AFTER_BIZ_IMAGE')}
            path='project/editor'
            fileType='image'
            max={10}
            error={errors.afterImages}
            rules={{
              required: isEn ? 'Please upload the after images.' : '이후 이미지를 업로드해주세요.',
            }}
            required
          />
        </div>
      </article>
      {evidenceList?.length > 0 && (
        <section className='bg-white py-12 border-t border-solid border-slate-200'>
          <header>
            <h2 className='font-semibold mb-4 pb-2'>{t('SUPPORTING_DOC')}</h2>
          </header>
          <div className='flex flex-col gap-4'>
            <FormEvidence
              control={control}
              name='evidence'
              // rules={{ required: validations?.evidence?.required }}
              error={errors.evidence}
              updatedEvidence={updatedEvidence}
              labels={evidenceList?.map((item) => ({
                title: isEn ? item.evidence?.titleEn || item.evidence?.title : item.evidence?.title,
                isForce: item.isForce,
                seq: item.evidence?.seq || item.evidenceSeq,
              }))}
              disabled={false}
              readOnly={false}
            />
          </div>
        </section>
      )}
      <section className='bg-white pt-12 border-t border-solid border-slate-200'>
        <header>
          <h2 className='font-semibold mb-4 pb-2'>{t('ADDITIONAL_DOC')}</h2>
        </header>
        <div className='flex flex-col gap-4 py-4'>
          <FormAdditionalEvidence
            control={control}
            name='additionalEvidence'
            error={errors.additionalEvidence}
            disabled={false}
            readOnly={false}
          />
        </div>
      </section>
    </article>
  );
};
